/*
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */

export const lightTheme = {
  body: '#FAFAFA',
  text: '#282C34',
  toggleBorder: '#999',
  links: '#0060df',
  rawPingActiveLineBackground: '#fff8c5',
  invert: '0%'
};

export const darkTheme = {
  body: '#282C34',
  text: '#FAFAFA',
  toggleBorder: '#6B8096',
  links: '#9da2ff',
  rawPingActiveLineBackground: '#c69026',
  invert: '100%'
};
